import React, { ButtonHTMLAttributes, MouseEventHandler } from 'react';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: MouseEventHandler;
  className?: string;
  disabled?: boolean;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}

// eslint-disable-next-line react/display-name
const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, className, ...props }: Props, ref) => {
    const finalClassname = `h-[88px] px-[52px] text-3xl transition duration-300 ease-in-out lg:focus:shadow-lg lg:focus:scale-105 flex flex-row justify-center text-center items-center ${
      props.disabled
        ? 'bg-bgColor-btnSecondary text-fontColor-btnDisabled'
        : 'bg-bgColor-btnPrimary text-fontColor-btnPrimary'
    } rounded-full ${className}`;
    return (
      <button ref={ref} className={finalClassname} {...props}>
        {children}
      </button>
    );
  }
);

export default Button;
